import AssignedStudentsTableLoader from './parts/AssignedStudensTableLoader';
import AssignedStudentsTable from './parts/AssignedStudentsTable';
import { useParams } from 'react-router-dom';
export default function AssignedStudents() {
  const { teacherId } = useParams<{ teacherId: string }>();

  return (
    <AssignedStudentsTableLoader teacherId={teacherId}>
      <AssignedStudentsTable teacherId={teacherId} />
    </AssignedStudentsTableLoader>
  );
}
